export const iOSDeviceWarning =
  'Please use Safari if accessing on a MacBook, iPhone, or iPad';
